export default "__VITE_ASSET__Dxf0RTxz__"